import { ERROR_MESSAGE_REQUIRED } from '../../config'
import FormSlide from '../FormSlide'

export default function YourWorkingGroupSlide (props) {
  return (
    <FormSlide
      title='What do you want to be involved in?'
      stageName='Finding your place at Aragon'
      description='Within the AN DAO we have multiple groups who are collaborating to help make Aragon not only a great governance software, but also a great web3 community as well!'
      formData={[
        {
          type: 'accordian',
          label: 'workingGroup',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED },
          options: [
            {
              title: 'Content-PR',
              value: 'Content-PR',
              body:
                'Our Content and PR people keep up with the latest in web3 and create content that helps educate and promote web3 and Aragon.'
            },
            {
              title: 'Legal',
              value: 'Legal',
              body:
                'Mission: Facilitate decisions of disputes within the DAO, bridge the chasm between the "old world" and these newly created governance framework by providing guidance and assistance to set up a DAO with knowledge, tools to handle taxes, regulation and compliance.'
            },
            {
              title: 'Biz-dev',
              value: 'Biz-dev',
              body:
                'Mission: Our Biz Dev Guild finds and helps users work through challenges holding them back from launching a DAO. They also maintain organized and up-to-date records of the challenges and outcomes of our potential users and position Aragon as compelling infrastructure whenever appropriate.'
            },
            {
              title: 'Design',
              value: 'Design',
              body:
                'Mission: Understand the community vision and perception about Aragon to adapt and integrate to the brand. Visualize & identify the paths from the users to design nice experiences across the website/products.'
            },
            {
              title: 'Academy',
              value: 'Academy',
              body:
                'Mission: Enable peer-to-peer learning by creating interactive modules that nurture skills needed to support the DAO and the web3 community.'
            },
            {
              title: 'Tech Support',
              value: 'Tech Support',
              body:
                "The guild is on the front-line of the Aragon Network, representing the first interactions with new users of Aragon's suite of products. Members of the guild assist the our community with any issues they may have while creating a DAO."
            }
          ]
        }
      ]}
      {...props}
    />
  )
}
